module.exports = __webpack_public_path__ + "img/嘴唇.6bfa8ea6.png";